import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["components", "styles"];
import React, { useState } from 'react';
import { OverridesContext } from "../hooks/OverridesContext.js";
import { MapContext } from "../hooks/useMap.js";
import { decorateName } from '@unmapped/core/utils';
export var UnmappedLayout = Component => decorateName(_ref => {
  var {
      components = {},
      styles = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var [mapHandle, setMapHandle] = useState(null);
  var AliasedComponent = Component;
  return /*#__PURE__*/React.createElement(MapContext.Provider, {
    value: {
      mapHandle,
      setMapHandle
    }
  }, /*#__PURE__*/React.createElement(OverridesContext.Provider, {
    value: {
      components,
      styles
    }
  }, /*#__PURE__*/React.createElement(AliasedComponent, _extends({
    components: components,
    styles: styles
  }, rest))));
}, 'UnmappedLayout');
export default UnmappedLayout;
//# sourceMappingURL=index.js.map